import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "filter-bar" }
const _hoisted_2 = { class: "filter-bar__content" }
const _hoisted_3 = { class: "filter-bar__unit-selector" }
const _hoisted_4 = { class: "filter-bar__unit-text" }
const _hoisted_5 = { class: "filter-bar__chips" }
const _hoisted_6 = { class: "filter-bar__count" }
const _hoisted_7 = { class: "filter-bar__count-text" }

import { computed, ref } from "vue";
import type { PatientCategory, UnitOption } from "@virtual-care/shared";

interface Props {
  totalCount: number;
  filterCounts: {
    overdue: number;
    "discharge-ready": number;
    "condition-discharge": number;
    "new-admit": number;
    other: number;
  };
  selectedFilters: Set<PatientCategory>;
  selectedUnit: string | null;
  units: UnitOption[];
}

interface Emits {
  (e: "toggle-filter", category: PatientCategory): void;
  (e: "unit-change", unitId: string): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PatientFilterBar',
  props: {
    totalCount: {},
    filterCounts: {},
    selectedFilters: {},
    selectedUnit: {},
    units: {}
  },
  emits: ["toggle-filter", "unit-change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isUnitMenuOpen = ref(false);

const filterChips = computed(() => [
  {
    id: "discharge-ready" as PatientCategory,
    label: `${props.filterCounts["discharge-ready"]} Discharge Ready`,
    color: "#EEF5EF",
    selected: props.selectedFilters.has("discharge-ready"),
  },
  {
    id: "condition-discharge" as PatientCategory,
    label: `${props.filterCounts["condition-discharge"]} Conditional Discharge`,
    color: "#FEF3E8",
    selected: props.selectedFilters.has("condition-discharge"),
  },
  {
    id: "new-admit" as PatientCategory,
    label: `${props.filterCounts["new-admit"]} New Admit`,
    color: "#E8EEFB",
    selected: props.selectedFilters.has("new-admit"),
  },
]);

const handleFilterClick = (category: PatientCategory) => {
  emit("toggle-filter", category);
};

const handleUnitChange = (unitId: string) => {
  emit("unit-change", unitId);
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_chip = _resolveComponent("v-chip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_select, {
          "model-value": __props.selectedUnit,
          items: __props.units,
          "item-title": "name",
          "item-value": "id",
          variant: "plain",
          density: "compact",
          "hide-details": "",
          class: "filter-bar__unit-select",
          "onUpdate:modelValue": handleUnitChange,
          "onUpdate:menu": _cache[0] || (_cache[0] = ($event: any) => (isUnitMenuOpen.value = $event))
        }, {
          selection: _withCtx(({ item }) => [
            _createElementVNode("span", _hoisted_4, _toDisplayString(item.title), 1),
            _createVNode(_component_v_icon, {
              size: "16",
              color: "#000000",
              class: "filter-bar__unit-arrow"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(isUnitMenuOpen.value ? "mdi-chevron-up" : "mdi-chevron-down"), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model-value", "items"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(__props.totalCount) + " PATIENTS", 1)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterChips.value, (chip) => {
          return (_openBlock(), _createBlock(_component_v_chip, {
            key: chip.id,
            class: _normalizeClass(['filter-bar__chip', `filter-bar__chip--${chip.id}`]),
            color: chip.selected ? '#291758' : chip.color,
            variant: chip.selected ? 'flat' : 'flat',
            size: "default",
            rounded: false,
            onClick: ($event: any) => (handleFilterClick(chip.id))
          }, {
            default: _withCtx(() => [
              (chip.selected)
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 0,
                    start: "",
                    size: "18"
                  }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createTextVNode("mdi-check", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(chip.label), 1)
            ]),
            _: 2
          }, 1032, ["class", "color", "variant", "onClick"]))
        }), 128))
      ])
    ])
  ]))
}
}

})